<div class="footer container-fluid text-center">
   <div class="pb-3 pt-5">

      <div class="row align-items-center">
         <ng-container *ngIf="(isRouteBySimpleFlow$ | async) === false">
            <div class="col-12 col-sm-6 col-md-3 col-xl-2 text-start align-self-start">
               <a href="{{ 'SHARED.LINKS.BLOG.LINK' | translate }}"
                  [translate]="'SHARED.LINKS.BLOG.TEXT'"
                  class="footer-link"
                  target="_blank"></a>
               <a href="{{ 'SHARED.LINKS.ABOUT-US.LINK' | translate }}"
                  [translate]="'SHARED.LINKS.ABOUT-US.TEXT'"
                  class="footer-link"
                  target="_blank"></a>
               <a href="{{ 'SHARED.LINKS.INFO-FOR-SALONS.LINK' | translate }}"
                  [translate]="'SHARED.LINKS.INFO-FOR-SALONS.TEXT'"
                  class="footer-link"
                  target="_blank"></a>
               <a href="/cookie-policy"
                  class="footer-link"
                  [translate]="'SHARED.COOKIE-CONSENT-POPUP.POLICY'"></a>
            </div>
            <div class="col-12 col-sm-6 col-md-3 col-xl-2 text-start align-self-start">
               <a href="{{ 'SHARED.LINKS.GIFT-AD.LINK' | translate }}"
                  [translate]="'SHARED.LINKS.GIFT-AD.TEXT'"
                  class="footer-link"
                  target="_blank"></a>

               <a href="{{ 'SHARED.LINKS.BARBER-BOOKING.LINK' | translate }}"
                  class="footer-link"
                  [translate]="'SHARED.LINKS.BARBER-BOOKING.TEXT'"
                  target="_blank"></a>

               <a href="#"
                  title="Change the Bjootify language"
                  class="footer-link"
                  *ngIf="currentLang === Languages.Dutch"
                  (click)="useLanguage(Languages.English); false"
                  [translate]="'SHARED.LANGUAGE-LABELS.ENGLISH'"></a>

               <a href="#"
                  title="Change the Bjootify language"
                  class="footer-link"
                  *ngIf="currentLang === Languages.English"
                  (click)="useLanguage(Languages.Dutch); false"
                  [translate]="'SHARED.LANGUAGE-LABELS.DUTCH'"></a>

               <a href="{{ 'SHARED.LINKS.DISCLAIMER.LINK' | translate }}"
                  [translate]="'SHARED.LINKS.DISCLAIMER.TEXT'"
                  class="footer-link"
                  target="_blank"></a>
            </div>

            <div class="col-12 col-md-2 col-xl-2 text-start align-self-start">
               <a href="{{ 'SHARED.LINKS.INSTAGRAM.LINK' | translate }}"
                  class="me-3 d-inline-block footer-link"
                  target="_blank"
                  title="{{ 'SHARED.LINKS.INSTAGRAM.TEXT' | translate }}">
                  <i-feather name="instagram"> </i-feather>
               </a>

               <a href="{{ 'SHARED.LINKS.FACEBOOK.LINK' | translate }}"
                  class="me-3 d-inline-block footer-link"
                  target="_blank"
                  title="{{ 'SHARED.LINKS.FACEBOOK.TEXT' | translate }}">
                  <i-feather name="facebook"> </i-feather>
               </a>
            </div>
         </ng-container>

         <div class="col-12 col-md-4 col-xl-6 ms-auto davinci-note">
            <p class="mb-0">
               <a target="_blank"
                  class="d-inline-block text-underline m-0 footer-link"
                  href="https://www.bjootify.com">{{ 'SHARED.FOOTER.LINK-TEXT' | translate }}</a> - {{ 'SHARED.FOOTER.SHORT-TEXT' | translate }}
            </p>
            <p class="mb-0">
               {{ 'SHARED.FOOTER.MADE-BY' | translate }}&nbsp;<a target="_blank"
                  class="d-inline-block text-underline m-0 footer-link"
                  [translate]="'SHARED.LINKS.DA-VINCI-SALON-SOFTWARE.TEXT'"
                  href="{{ 'SHARED.LINKS.DA-VINCI-SALON-SOFTWARE.LINK' | translate }}">
               </a>
            </p>
         </div>
      </div>

   </div>
</div>
